export default function SavoirFaire({ data, addRef }) {
  return (
    <section id="savoir-faire" className="sf-section">
      <p className="section-label">{data.sectionLabel}</p>
      <div className="sf-grid">
        {data.blocks.map((block, i) => (
          <div
            className="sf-block fade-in"
            key={i}
            ref={addRef}
            style={i > 0 ? { transitionDelay: "0.2s" } : {}}
          >
            <h3>
              {block.title}<br />
              <em>{block.titleEmphasis}</em>
            </h3>
            <div className="sf-divider" />
            {block.paragraphs.map((p, j) => <p key={j}>{p}</p>)}
            <div className="sf-tags">
              {block.tags.map((tag) => (
                <span className="sf-tag" key={tag}>{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
